import * as React from "react";

const HeaderNavArrowFocus: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 11"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fill="#0A57A4" d="M1.446 1.142L5.36 5.298a.655.655 0 010 .903l-3.913 4.156a.657.657 0 01-.953-.904l3.51-3.705-3.51-3.705a.657.657 0 01.953-.901z"/></svg>;
};

export default React.memo(HeaderNavArrowFocus);
